import { useEffect } from 'react';
import socketConnection from 'components/SocketConnection';
import SocketChannels from '../../../../../../socket_server/SocketChannels';

// Off the netplay page the dock shows the player's rooms, so the socket takes
// their messages (the chats channel) while there are rooms. The dock never
// focuses a room on the socket, so no userlist updates come with them. The
// netplay page claims chats itself once it has joined its rooms.
export default function useDockChatChannels(hasRooms, onNetplay) {
	const wanted = hasRooms && !onNetplay;
	useEffect(() => {
		if(!wanted) {
			return undefined;
		}
		return socketConnection.claimChannels({ channels: [SocketChannels.CHATS], presence: false });
	}, [wanted]);
}
